import { TaskDataStore } from '@skinsoft/entity';
import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { EntityHistory } from '@skinsoft/ui';
import { defineComponent } from 'vue';

import { Task } from '@skinsoft/types';
import { toHistoryRecord$ } from '../../serializer/history';

export const TaskHistory = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sEntityHistory: EntityHistory,
    },
    props: ['targetRouteName'],
    template: require('./task-history.html'),
    data() {
        return {
            historyStates: TaskDataStore.historyStates,
            serializer: (task: Task) => toHistoryRecord$(task, undefined), // undefined just for avoiding problem with this at initialization
            sortFields: TaskDataStore.sortFields,
        }
    },
    mounted() {
        // passing directlt this.$i18n.locale to the toFeatured inside the serializer arrow function
        // was not working as the "this" was not pointing to the TaskHistory class
        const locale = this.getAppLocale()
        this.serializer = (task: Task) => toHistoryRecord$(task, locale)
    },
})
